import axios from "../../utils/axios";

export const add_config = async (payload) => {
    const response = await axios.post(`/admin/config`, payload);
    const { data } = response;

    return data;
};

export const get_config = async (config, query) => {
    const response = await axios.get(`/admin/config?config=${config}&query=${query}`);
    const { data } = response;

    return data;
};

export const delete_config = async (payload) => {
    const response = await axios.delete(`/admin/config/${payload?.value_id}?config=${payload?.config}`);
    const { data } = response;

    return data;
};


export const get_cities = async (query) => {
    const response = await axios.get(`/admin/cities?query=${query}`);
    const { data } = response;

    return data;
};

export const get_buyers = async (query) => {
    const response = await axios.get(`/admin/buyers?query=${query}`);
    const { data } = response;

    return data;
};

// Stock Categories API
export const get_all_categories = async () => {
    const response = await axios.get(`/admin/stock-categories`);
    return response.data;
};

export const create_category = async (payload) => {
    const response = await axios.post(`/admin/stock-categories`, payload);
    return response.data;
};

export const update_category = async (id, payload) => {
    const response = await axios.put(`/admin/stock-categories/${id}`, payload);
    return response.data;
};

export const delete_category = async (id) => {
    const response = await axios.delete(`/admin/stock-categories/${id}`);
    return response.data;
};

// Mode de Règlement API
export const get_all_mode_reglements = async () => {
    const response = await axios.get(`/admin/mode-reglements`);
    return response.data;
};

export const create_mode_reglement = async (payload) => {
    const response = await axios.post(`/admin/mode-reglements`, payload);
    return response.data;
};

export const update_mode_reglement = async (id, payload) => {
    const response = await axios.put(`/admin/mode-reglements/${id}`, payload);
    return response.data;
};

export const delete_mode_reglement = async (id) => {
    const response = await axios.delete(`/admin/mode-reglements/${id}`);
    return response.data;
};

// Commercial Product Assignments API
export const get_commercials_with_assignments = async () => {
    const response = await axios.get(`/admin/commercial-products`);
    return response.data;
};

export const get_commercial_products = async (commercialId) => {
    const response = await axios.get(`/admin/commercial-products/${commercialId}`);
    return response.data;
};

export const assign_product = async (commercialId, stockId) => {
    const response = await axios.post(`/admin/commercial-products`, {
        commercial_id: commercialId,
        stock_id: stockId
    });
    return response.data;
};

export const bulk_assign_products = async (commercialId, stockIds, assignments) => {
    const response = await axios.post(`/admin/commercial-products/bulk`, {
        commercial_id: commercialId,
        stock_ids: stockIds,
        assignments: assignments
    });
    return response.data;
};

export const unassign_product = async (assignmentId) => {
    const response = await axios.delete(`/admin/commercial-products/${assignmentId}`);
    return response.data;
};

// Product Images API
export const get_product_images = async (stockId) => {
    const response = await axios.get(`/admin/product-images/${stockId}`);
    return response.data;
};

export const upload_product_image = async (stockId, formData) => {
    const response = await axios.post(`/admin/product-images/${stockId}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
};

export const delete_product_image = async (imageId) => {
    const response = await axios.delete(`/admin/product-images/${imageId}`);
    return response.data;
};

export const reorder_product_images = async (stockId, imageOrders) => {
    const response = await axios.put(`/admin/product-images/${stockId}/reorder`, {
        image_orders: imageOrders
    });
    return response.data;
};

export const set_principal_image = async (imageId) => {
    const response = await axios.put(`/admin/product-images/${imageId}/set-principal`);
    return response.data;
};

// Prix de Vente Toggle
export const get_prix_vente_toggle = async () => {
    const response = await axios.get(`/admin/settings/prix-vente-toggle`);
    return response.data;
};

export const set_prix_vente_toggle = async (enabled) => {
    const response = await axios.post(`/admin/settings/prix-vente-toggle`, { enabled });
    return response.data;
};